import React from "react";
import { forwardRef } from "react";
import style from "./Inputs.module.css";
import CurrencyInput from "react-currency-input-field";
import { convertToEnglishNumbers } from "../../../utils/generalUtils";

const BigNumberInput = forwardRef<HTMLInputElement, componentProps>(function BigNumberInput(
  { label, placeholder, isSecondary, note, error, isRequired, ...rest },
  ref,
) {
  return (
    <div className={`${style.input_container}`}>
      {label && (
        <label>
          {label}
          {!!isRequired && <span className={style.reqFeild}>*</span>}
        </label>
      )}

      <CurrencyInput
        className={`${style.input}${isSecondary ? ` ${style["input--secondary"]}` : ""}`}
        placeholder={placeholder}
        autoComplete="true"
        {...rest}
        {...(rest?.name ? { id: rest.name } : {})}
        ref={ref}
        transformRawValue={(v) => {
          return convertToEnglishNumbers(v);
        }}
      />
      {note && <span className={style.input_note}>{note}</span>}
      {error && (
        <span className={style.input_note} style={{ color: "#dc0000" }}>
          {error}
        </span>
      )}
    </div>
  );
});

export default BigNumberInput;
type componentProps = {
  label?: string;
  placeholder?: string;
  isSecondary?: boolean;
  note?: string;
  isRequired?: boolean;
  error?: any;
} & React.ComponentProps<typeof CurrencyInput>;
